import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <h3 className="footer-logo">
            Lansly<span className="logo-dot">.</span>
          </h3>
          <p className="footer-description">{t('footer.tagline')}</p>
        </div>
        <div className="footer-info">
          <nav className="footer-links">
            <a
              href="http://pf.kakao.com/_KQrhn"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              {t('footer.contact')}
            </a>
            <span className="footer-sep" aria-hidden="true">
              ·
            </span>
            <Link to="/terms" className="footer-link">
              {t('footer.terms')}
            </Link>
            <span className="footer-sep" aria-hidden="true">
              ·
            </span>
            <Link to="/privacy" className="footer-link">
              {t('footer.privacy')}
            </Link>
          </nav>
          {/* 사업자 정보 값은 법적 사실이라 번역하지 않음 — 라벨만 번역 */}
          <p className="footer-legal">
            <span>{t('footer.bizName')}: 토이플(Toyple)</span>
            <span>{t('footer.ceo')}: 백경인</span>
            <span>{t('footer.bizNumber')}: 601-55-00778</span>
            <span>{t('footer.mailOrder')}: 2025-서울강동-0817</span>
          </p>
          <p className="footer-legal">
            <span>{t('footer.address')}: 서울특별시 강동구 성내동 37-48, 2동 302호</span>
            <span>{t('footer.phone')}: +82-10-8515-1619</span>
            <span>{t('footer.email')}: admin@toyple.net</span>
          </p>
          {/* 통신판매중개 플랫폼 필수 고지 — 거래 책임·민원 처리 주체 */}
          <p className="footer-legal footer-liability">
            <span>{t('footer.liability')}</span>
            <span>{t('footer.complaintOfficer')}: 백경인 / 010-8515-1619</span>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          <span>&copy; 2024 Toyple.</span> {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
